import React, { useEffect } from 'react';
// import SwitchLanguageAlert from '@/components/switch-language-alert';
import Header from './components/Header';
import Footer from './components/Footer';
import BackTop from '@/components/back-top';
import HeaderNav from './components/header-nav';
import 'antd/dist/reset.css';
import '@styles/components.css';
import '@styles/nottas-test-awesome-project-te-a9620974.css';
import '@styles/core/index.less';
import useGoogleOneTap from '@/hooks/useGoogleOneTap';
import Head from '@/components/head';
import { loadFont } from '@/utils';
// import StopServingBanner from './components/stop-serving';

interface IProps {
  children: React.ReactNode;
  isMediaTool?: boolean;
  isNewLayout?: boolean;
}

const Layout: React.FC<IProps> = ({ children, isMediaTool = false, isNewLayout = false }) => {
  useGoogleOneTap();

  useEffect(() => {
    loadFont(
      'LINESeedJPStd',
      'normal',
      400,
      'https://www.notta.ai/static/lineseedjp_otf_rg-eaa3c4176a47b0e17366b9388cead2e9.woff2',
    );
    loadFont(
      'LINESeedJPStd',
      'normal',
      700,
      'https://www.notta.ai/static/lineseedjp_otf_bd-8b2b454fe40760a8f83aba801dbc641b.woff2',
    );
    loadFont(
      'LINESeedJPStd',
      'normal',
      800,
      'https://www.notta.ai/static/lineseedjp_otf_eb-ff47c6085693d4f7a6fb4c49c7252623.woff2',
    );
  }, []);

  return (
    <>
      <div className="w-embed" />
      <div id="page-anchor-top" className="page-anchor" />
      <Head htmlAttr={{ lang: 'ja' }} />
      {/* <SwitchLanguageAlert /> */}
      {/* <StopServingBanner type="ja" /> */}
      <HeaderNav />
      {/* <Header isMediaTool={isMediaTool} isNewLayout={isNewLayout} /> */}
      {children}
      <BackTop />
      <Footer isMediaTool={isMediaTool} isNewLayout={isNewLayout} />
    </>
  );
};

export default Layout;
